import useSWR from 'swr'
import type {Iri} from '../../@types/Api'
import type {OrganizationCollection, OrganizationItem} from '../../@types/entity/Organization'
import type {FetchOption} from '../../components/EnhancedTable/types'
import {createCollectionIri} from '../../utils/iri'
import {type FilterOption, filterToQueryString, useGet} from '../useApi'
import {useSpotHelperGetCurrent} from './useSpot'

type GetResponse = {
  readonly organization?: OrganizationItem
  readonly error?: Error
}

type CollectionResponse = {
  readonly organizations?: OrganizationCollection
  readonly error?: Error
}

type OrganizationCollectionFilter = {
  readonly organizationIri?: Iri
  readonly organizationIris?: Iri[]
}
const collectionFilterOptions: FilterOption<OrganizationCollectionFilter> = {
  organizationIri: 'id',
  organizationIris: 'id',
}

export const useOrganizationGet = (organizationIri: Iri | undefined): GetResponse => {
  const {data, error} = useGet(organizationIri)

  return {
    organization: data,
    error,
  }
}

export const useOrganizationCollection = (filter: OrganizationCollectionFilter | undefined, fetchOptions?: FetchOption, enabled = true): CollectionResponse => {
  const querystring = filterToQueryString<OrganizationCollectionFilter>(collectionFilterOptions, enabled ? filter : undefined, fetchOptions)
  const {
    data,
    error,
  } = useSWR(enabled && querystring ? `${createCollectionIri('organizations')}?${querystring.toString()}` : null)
  return {
    organizations: data,
    error,
  }
}

export const useOrganizationIriFromCurrentSpot = (): string | undefined => {
  const {spot} = useSpotHelperGetCurrent()

  return spot?.organization
}
